import React from "react";

export default function Refund() {
	return (
		<>
			<div>
				<div>
					<h1 className="text-3xl font-bold text-gray-700 mt-10">
						Refund & Cancellation Policy
					</h1>
					<div className="py-10 sm:px-20 px-10">
						<p align="justify" className="mb-32 font-semibold text-gray-700">
							We provide two course trial alternatives to students who are
							interested in enrolling with TathaGat. A student may sign up for a
							15-day course trial OR a demo class. A student may take the 15-day
							trial course, once he/she has enrolled by paying the fee as per
							the offered plan. The 15-day trial period is subject to the fee
							refund policy. If, over the course of 15- day trial—during which
							there will be at least 4–5 classes—a student experiences any
							problems, or, for any reason, decides against continuing with the
							enrolment, an unconditional fee refund will be provided. The
							students who sign up for the demo class will not be entitled to a
							fee refund. Also, any student who has been offered a fee rebate
							for any reasons shall not be eligible for any refund. This refund
							policy is applicable to all Fee for Self paid Students and
							Sponsored students who have paid Full Fee / Partial Fee.
							<br />
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
